import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { UserActions } from "./user.actions";
import { map, switchMap } from "rxjs";
import { UserService } from '../../@shared/user.service';


@Injectable()
export class UserEffects {
    getCurrentUser = createEffect(() => this.actions$.pipe(
        ofType(UserActions.getCurrentUser),
        switchMap(() => this.userService.getCurrentUser().pipe(
            map(response => UserActions.setCurrentUser({ user: response.data }))
        ))
    ));
    constructor(
        private actions$: Actions,
        private userService: UserService
    ) { }
}

